import { PayloadAction } from '@reduxjs/toolkit';
import { ImportAlphaSpreadsheetResponse } from '@snap-types/actions/import-alpha-spreadsheet';

import { WritableAutoConfiguratorState } from '../slice';
import { revalidateLineQuantities } from '../validation/revalidate-line-quantities';
import { buildImportedLineState } from './build-imported-line-state';

type AppendImportedLineItemsPayload = {
  importedLineItems: ImportAlphaSpreadsheetResponse;
};

export function appendImportedLineItems(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<AppendImportedLineItemsPayload>,
) {
  const { importedLineItems } = action.payload;

  let nextLineNumber = state.lineItemUuids.length + 1;

  for (const importedQuoteLine of importedLineItems) {
    if (state.lineItems[importedQuoteLine.uuid]) {
      continue;
    }

    const { lineItem, quantityBreaks } = buildImportedLineState(
      importedQuoteLine,
      nextLineNumber,
    );

    nextLineNumber += 1;

    state.lineItemUuids.push(lineItem.uuid);
    state.lineItems[lineItem.uuid] = lineItem;

    for (const quantityBreak of quantityBreaks) {
      state.quantityBreaks[quantityBreak.uuid] = quantityBreak;
    }

    revalidateLineQuantities(state, lineItem.uuid);
  }
}
